import * as Types from './userActionTypes.js'

const initialState = {
    userToken : '',
    userInfo : ''
};

export default function user(state = initialState, action) {
    switch (action.type) {
        case Types.SET_USERTOKEN:
            if(state.userToken !== action.userToken) {
                return Object.assign({}, state, {userToken: action.userToken});
            }
            return state;
        case Types.SET_USERINFO:
            if(state.userInfo !== action.userInfo) {
                return Object.assign({}, state, {userInfo: action.userInfo});
            }
            return state;
        default:
            return state;
    }
}